export default `uniform sampler2D uBaseHeights;
uniform float uWorldSize;
uniform float uWorldHalf;
uniform float uVariation;
uniform vec3 uStrataLow;
uniform vec3 uStrataMid;
uniform vec3 uStrataHigh;
uniform vec3 uTopDust;
uniform vec3 uFogColor;
uniform float uFogDensity;
uniform float uFogHeightFalloff;
uniform float uFogStart;
uniform float uSunScatter;
uniform vec3 uSunDir;
uniform float uStormDensity;
uniform vec3 uStormOrigin;
uniform float uFlatStart;
uniform float uFlatEnd;

varying vec3 vWorldPos;
varying float vAO;
varying float vScale;
flat varying float vFace;

float hash13(vec3 p) {
    p = fract(p * vec3(0.1031, 0.1030, 0.0973));
    p += dot(p, p.yxz + 33.33);
    return fract((p.x + p.y) * p.z);
}

vec3 terrainTint(vec3 worldPos) {
    float col = clamp(floor(worldPos.x + uWorldHalf + 0.001), 0.0, uWorldSize - 1.0);
    float row = clamp(floor(worldPos.z + uWorldHalf + 0.001), 0.0, uWorldSize - 1.0);
    vec2 uv = (vec2(col, row) + 0.5) / uWorldSize;
    float baseH = texture2D(uBaseHeights, uv).r;
    float depth = clamp((baseH + 0.5 - worldPos.y) / 42.0, 0.0, 1.0);

    
    
    float farFlat = smoothstep(uFlatStart, uFlatEnd, distance(worldPos, cameraPosition));

    float elevation = clamp(worldPos.y / 96.0, 0.0, 1.0);
    vec3 color = mix(uStrataLow, uStrataHigh, elevation);
    float band = sin(worldPos.y * 0.62) * 0.5 + 0.5;
    float stripe = smoothstep(0.4, 0.5, band) * (1.0 - smoothstep(0.5, 0.64, band));
    color = mix(color, uStrataMid, stripe * 0.85 * (1.0 - farFlat));

    float topFace = (vFace > 1.5 && vFace < 2.5) ? 1.0 : 0.0;
    color = mix(color, uTopDust, 0.64 * mix(topFace, 1.0, farFlat));

    color *= mix(1.0, 0.52, depth);

    float scale = max(vScale, 1.0);
    vec3 block = floor((worldPos + vec3(uWorldHalf, 0.0, uWorldHalf)) / scale);
    float grain = hash13(block);
    float dist = distance(worldPos.xz, cameraPosition.xz);
    float fade = 1.0 - smoothstep(30.0, 170.0, dist);
    color *= mix(1.0, 0.9 + grain * uVariation, fade);
    return color;
}`